import { ConnectionState } from 'livekit-client'

interface ConnectionStatusProps {
    state: ConnectionState
}

export function ConnectionStatus({ state }: ConnectionStatusProps) {

    const getConnectionStatusColor = () => {
        switch (state) {
            case ConnectionState.Connected:
                return '#00ff00'
            case ConnectionState.Connecting:
            case ConnectionState.Reconnecting:
                return '#ffff00'
            case ConnectionState.Disconnected:
                return '#ff0000'
            default:
                return '#888'
        }
    }

    const getConnectionStatusText = () => {
        switch (state) {
            case ConnectionState.Connected:
                return 'Connected'
            case ConnectionState.Connecting:
                return 'Connecting...'
            case ConnectionState.Reconnecting:
                return 'Reconnecting...'
            case ConnectionState.Disconnected:
                return 'Disconnected'
            default:
                return 'Unknown'
        }
    }
    return (
        <div className="absolute top-5 left-5 z-10 flex items-center gap-2 bg-black/70 backdrop-blur-md px-3 py-2 rounded-full border border-white/10 text-white text-sm font-medium shadow-[0_4px_20px_rgba(0,0,0,0.3)]">
            <div
                className="w-2 h-2 rounded-full animate-pulse"
                style={{ backgroundColor: getConnectionStatusColor() }}
            />
            <span className="text-[13px] whitespace-nowrap">
                {getConnectionStatusText()}
            </span>
        </div>
    )
}
